<template>
    <ModalBase modal-type="error" @close="$emit('close')">
        <template #header>
            {{ $t('component.modal.hideFamily.title') }}
        </template>
        <template #body>
            <div class="w-full flex">
                <div v-if="error" class="w-3/3 text-red-600 font-bold text-center">
                    {{ error }}
                </div>
            </div>

            <div class="text-center">
                {{ $t('component.modal.hideFamily.message') }}
            </div>
        </template>
        <template #footer-without-padding>
            <div class="w-full flex justify-end px-4 pb-4">
                <button type="button" class="border p-2 px-4 rounded shadow hover:bg-gray-100 mr-2" @click="$store.commit('app/hideHideFamilyDialog')">{{ $t('component.modal.hideFamily.no')}}</button>
                <button class="border p-2 px-6 rounded shadow hover:bg-gray-100" @click="hideFamily">{{ $t('component.modal.hideFamily.yes') }}</button>
            </div>
        </template>
    </ModalBase>
</template>

<script>
    import ModalBase from "@/components/shared/ModalBase";
    import CustomerService from "../../services/customer.service";

    export default {
        name: "HideFamilyDialog",
        props: ['mission'],
        components: {
            ModalBase
        },
        data() {
            return {
                error: ''
            }
        },
        methods: {
            hideFamily() {
                CustomerService.toggleExclude(this.mission.customer_id)
                .then(() => {
                    this.$store.commit('app/hideHideFamilyDialog');
                    this.$store.dispatch('mission/removeMission', this.mission.mission_id);
                    this.$router.push({ name: 'missions' }).catch(()=>{});
                })
                .catch(() => {

                });
            }
        }
    }
</script>

<style>
</style>